import { faPlus, faTrash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { OAVirtualDigitalAssetsDetailsForm } from ".";
import { IFormITR1, IVirtualDigitalAssets } from "../../../config/interfaces";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";
import { ConfirmationModal } from "../../modals";

const OAVirtualDigitalAssetsDetails: React.FC = () => {
  const [showAddFormCanvas, setShowAddFormCanvas] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<IVirtualDigitalAssets | null>(null);
  const [activeItem, setActiveItem] = useState<IVirtualDigitalAssets | null>(null);
  // used in both edit and delete cases
  const [activeItemIdx, setActiveItemIdx] = useState<string>("");

  const { values, setFieldValue, setValues } = useFormikContext<IFormITR1>();
  const VirtualDigitalAssetsDestails = cloneDeep(values.IncomeDetails?.VirtualDigitalAssets || []);

  const handleDeleteInterestItem = async () => {
    VirtualDigitalAssetsDestails.splice(Number(activeItemIdx), 1);
    setFieldValue("IncomeDetails.VirtualDigitalAssets", VirtualDigitalAssetsDestails);
    setShowDeleteModal(() => null);
    setActiveItem(() => null);
    setActiveItemIdx(() => "");
    handleTotalCalculation();
  };

  const handleTotalCalculation = () => {
    const ICryptoIncome =
      VirtualDigitalAssetsDestails?.reduce((acc, curr) => {
        const value = parseInt(curr.Gains);
        return acc + (isNaN(value) ? 0 : value);
      }, 0) || 0;

    const _VDAIncomes = {
      TotalCryptoIncome: ICryptoIncome
    };

    const TotalVDAIncome = Object.values(_VDAIncomes)?.reduce((acc, curr) => {
      return acc + curr;
    }, 0);

    const DATA = {
      VirtualDigitalAssets: _VDAIncomes,
      TotalVirtualDigitalAsset: TotalVDAIncome
    };

    setValues({ ...cloneDeep(values), ...DATA });
    setFieldValue("IncomeDetails.VirtualDigitalAssets", VirtualDigitalAssetsDestails);
    setFieldValue("LastSavedTimeStamp", new Date().getTime());
  };

  return (
    <>
      <section>
        <div className="section-title-wrap">
          <h5>Crypto Income</h5>
          <PreventEditComponent>
            <Button variant="secondary" size="sm" onClick={() => setShowAddFormCanvas(() => true)}>
              <FASvgIcon icon={faPlus} />
              Add
            </Button>
          </PreventEditComponent>
        </div>

        <dl className="eds-list eds-dl eds-inline-between">
          {VirtualDigitalAssetsDestails.map((income, index) => {
            return (
              <div key={`any-asset-${index}`} className="eds-list--item">
                <dt>{income.NFTAssetName}</dt>
                <dd>
                  <span>
                    <PriceDisplay price={income?.Gains} />
                  </span>
                  <Button
                    variant="link"
                    onClick={() => {
                      setShowAddFormCanvas(() => true);
                      setActiveItem(() => income);
                      setActiveItemIdx(() => String(index));
                    }}
                  >
                    View
                    <PreventEditComponent>
                      <>/Edit</>
                    </PreventEditComponent>
                  </Button>
                  <PreventEditComponent>
                    <Button
                      variant="transparent"
                      className="icon-only"
                      onClick={() => {
                        setShowDeleteModal(() => income);
                        setActiveItemIdx(() => String(index));
                      }}
                    >
                      <FASvgIcon icon={faTrash} />
                    </Button>
                  </PreventEditComponent>
                </dd>
              </div>
            );
          })}
        </dl>
      </section>

      <OAVirtualDigitalAssetsDetailsForm
        showCanvas={showAddFormCanvas}
        handleCloseBtnPress={(assetData) => {
          if (assetData) {
            if (activeItem) {
              VirtualDigitalAssetsDestails.splice(Number(activeItemIdx), 1, assetData);
            } else {
              VirtualDigitalAssetsDestails.push(assetData);
            }
            handleTotalCalculation();
          }
          setShowAddFormCanvas(() => false);
          setActiveItem(() => null);
          setActiveItemIdx(() => "");
        }}
        formValues={activeItem}
      />

      <ConfirmationModal
        showModal={!!showDeleteModal}
        iconColorClass="text-danger"
        title="Are you sure?"
        message={<p>You want to delete this</p>}
        onYesBtnClick={() => handleDeleteInterestItem()}
        onNoBtnClick={() => setShowDeleteModal(() => null)}
        icon={faTrashAlt}
      />
    </>
  );
};

export default OAVirtualDigitalAssetsDetails;
